import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import ProtectedRoute from "../../components/routes/ProtectedRoute";
import DashboardPage from "../../pages/protected-pages/DashboardPage";
import GroupsViewPage from "../../pages/protected-pages/GroupsViewPage";
import GroupsPage from "../../pages/protected-pages/GroupsPage";
import SwapsPage from "../../pages/protected-pages/SwapsPage";
import MembersPage from "../../pages/protected-pages/MembersPage";
import ModerationPage from "../../pages/protected-pages/ModerationPage";
import MonitoringPage from "../../pages/protected-pages/MonitoringPage";
import ReportsPage from "../../pages/protected-pages/ReportsPage";
import TabsDesign from "../../pages/protected-pages/TabsDesign";
import TeamMember from "../../pages/protected-pages/TeamMember";
import MediaQueueViewer from "../MediaQueueViewer";
import DashboardFooter from "./DashboardFooter";
import DashboardHeader from "./DashboardHeader";
import MembersviewPage from "../../pages/protected-pages/MembersViewPage";

const DashboardLayout = ({ props }) => {
  return (
    <>
      <div className="mainWrapper">
        <DashboardHeader {...props} />
        <div className="innerWrapper">
          <Routes>
            <Route
              path=""
              element={<ProtectedRoute redirectRoute={"/login"} />}
            >
              <Route exact path="/dashboard" element={<DashboardPage />} />
              <Route exact path="/team-member" element={<TeamMember />} />
              <Route exact path="/groups" element={<GroupsPage />} />
              <Route exact path="/swaps" element={<SwapsPage />} />
              <Route exact path="/members" element={<MembersPage />} />
              <Route exact path="/moderation" element={<ModerationPage />} />
              <Route exact path="/monitoring" element={<MonitoringPage />} />
              <Route exact path="/reports" element={<ReportsPage />} />
              <Route
                exact
                path="/groups-view/:id"
                element={<GroupsViewPage />}
              />

              {/* <Route exact path="/groups-view" element={<GroupsViewPage />} /> */}

              <Route
                exact
                path="/members-view/:id"
                element={<MembersviewPage />}
              />
              <Route exact path="/tabs" element={<TabsDesign />} />
            </Route>

            <Route path="*" element={<Navigate replace to="/groups" />} />
          </Routes>

          <MediaQueueViewer />
        </div>

        <DashboardFooter />
      </div>
    </>
  );
};

export default DashboardLayout;
